import stableStringify from 'fast-json-stable-stringify'

export function createCacheKey(endpoint: string, args: unknown) {
  return `${endpoint}:${stableStringify(args ?? {})}`
}
